export default __webpack_public_path__ + "static/media/01.bec05235.png";